module.exports = __webpack_public_path__ + "static/10-defa43cc0f0e84c7a309ce1fa0ba32cc.jpg";